export const ChartLegendRectangle = ({ fill }: { fill: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <rect x="2" y="2" width="8" height="8" rx="1" fill={fill} />
  </svg>
);
